/* jshint node:true */
'use strict';

var React       = require('react');
var classNames  = require('classnames');

var Commentary = React.createClass({

    displayName: 'Commentary',

    componentDidMount: function(){
        try{
            /* Check for instance of tweet code in tweet and action if exists. */
            var myJs = document.getElementById('twitter-wjs');
            if(myJs == null){
                var js = document.createElement("script");
                js.id = "twitter-wjs";
                js.src = "//platform.twitter.com/widgets.js";
                document.getElementsByTagName('head')[0].appendChild(js);
            }else{
                twttr.widgets.load();
            }
        }catch(e){}
    },

    componentDidUpdate: function(prevProps, prevState) {
        try {
            // Load Twitter widgets upon component update
            twttr.widgets.load();
        }catch(e){}
    },

    getInitialState: function () {
        return {
            tab:'all', // all, key
            displayQuantity:3
        };
    },

    swapTab: function(){
        if(this.state.tab === 'all'){
            this.setState({tab:'key'});
        }else{
            this.setState({tab:'all'});
        }
    },

    viewAll: function(oEvent){
        if(this.props.changeView){
            this.props.changeView('commentary');
        }
    },

    render: function () {

        var aGameEvents = this.props.gameEvents || [];
        var sMatchState = this.props.matchState || [];
        var bShowAll    = (this.props.showAll === true) ? true : false;
        var aEventsList = [];
        var rHeader     = null;
        var rSubHeader  = null;
        var rFooter     = null;
        var sViewName   = 'Match Commentary';

        /* fix the ammount to show unless its all */
        var iEventLen = aGameEvents.length;

        if(iEventLen === 0){
            return null;
        }

        if(!bShowAll && iEventLen > this.state.displayQuantity){
            iEventLen = this.state.displayQuantity;
        }

        for (var i = 0; i < iEventLen; i++) {
            var oEvent  = aGameEvents[i];
            var props ={
                key:i,
                type:oEvent.type,
                text:oEvent.text,
                time:oEvent.time,
                homeScore:oEvent.homeScore,
                awayScore:oEvent.awayScore
            };

            if(this.state.tab !== 'all'){
                if(oEvent.type == 1 || oEvent.type == 2 || oEvent.type == 3 || oEvent.type == 4 || oEvent.type == 5 || oEvent.type == 6 || oEvent.type == 14){
                    aEventsList.push(
                        <CommentaryRow {...props} />
                    );
                }
            }else{
                aEventsList.push(
                    <CommentaryRow {...props} />
                );
            }

        }

        if(bShowAll){
            var aAllBtnClass = ['button-filter-alt','lg','fixed'];
            var aKeyBtnClass = ['button-filter-alt','lg','fixed'];
            if(this.state.tab === 'all'){
                aAllBtnClass.push('active');
            }else{
                aKeyBtnClass.push('active');
                sViewName = 'Key Events';
            }

            var sAllClasses    = classNames(aAllBtnClass);
            var sKeyClasses    = classNames(aKeyBtnClass);

            rHeader = (
                <header>
                    <div className="button-group" data-behavior="tabs">
                        <a className={sAllClasses} onClick={this.swapTab}>All Commentary</a>
                        <a className={sKeyClasses} onClick={this.swapTab}>Key Events</a>
                    </div>
                </header>
            );

            rSubHeader = (
                <header>
                    <h1>{sViewName}</h1>
                </header>
            );

        }else{
            rHeader = (
                <header>
                    <h1 style={{textAlign:'left'}}>{sViewName}</h1>
                </header>
            );

            rFooter = (
                <footer>
                    <a onClick={this.viewAll}>Full Commentary</a>
                </footer>
            );
        }

        return (
            <article className="sub-module match-commentary" data-behavior="accordion">
                {rHeader}
                <div className="content">
                    <div id="tab1">
                        {rSubHeader}
                        <table>
                            <tbody>
                                {aEventsList}
                            </tbody>
                        </table>
                    </div>
                </div>
                {rFooter}
            </article>
        );
    }

});

var CommentaryRow = React.createClass({

    displayName: 'CommentaryRow',

    render: function () {

        var iEventId    = this.props.id;
        var iEventType  = this.props.type;
        var sEventText  = this.props.text;
        var sEventTime  = this.props.time;
        var sHomeScore  = this.props.homeScore || 0;
        var sAwayScore  = this.props.awayScore || 0;
        var bShowScore  = false;
        var aIconClass  = ['game-icon','icon-font-before'];

        if (iEventType == 7 || iEventType == 8) {
            aIconClass.push('icon-soccer-substitution-before');
        } else if (iEventType == 9 || iEventType == 10 || iEventType == 11 || iEventType == 12 || iEventType == 13) {
            bShowScore  = true;
            aIconClass.push('icon-soccer-foul-solid-before');
        } else if (iEventType == 5) {
            //yellow
            aIconClass.push('icon-soccer-card02-solid-before');
            aIconClass.push('icon-yellowcard');
        } else if (iEventType == 3) {
            //penalty kick
            bShowScore  = true;
            aIconClass.push('icon-rugby-penalty-solid-before');
        } else if (iEventType == 4) {
            //drop goal
            bShowScore  = true;
            aIconClass.push('icon-rugby-drop-goal-solid-before');
        } else if (iEventType == 6) {
            aIconClass.push('icon-soccer-card02-solid-before');
            aIconClass.push('icon-redcard');
        } else if (iEventType == 1 || iEventType == 14) {
            //try or penalty try
            bShowScore  = true;
            aIconClass.push('icon-rugby-score-outline-before');
        } else if (iEventType == 2) {
            //conversion
            bShowScore  = true;
            aIconClass.push('icon-rugby-conversion-solid-before');
        }

        //icon-rugby-solid
        //icon-rugby-drop-goal-outline
        //icon-rugby-drop-goal-solid
        //icon-rugby-score-outline
        //icon-rugby-score-solid
        //icon-rugby-penalty-outline
        //icon-rugby-penalty-solid
        //icon-rugby-conversion-outline
        //icon-rugby-conversion-solid

        /* TODO hide symbol on mobile so tweets fit properly */

        // if event text then use div elements to HTML encode. (hackyyy...)
        if(sEventText.indexOf('\&lt\;') >= 0){
            var div = document.createElement('div');
            div.innerHTML = sEventText;
            sEventText = div.firstChild.nodeValue;
        }

        if(bShowScore){
            sEventText = '<span class="current-score">'+sHomeScore+'-'+sAwayScore+'</span> '+sEventText;
        }

        var sIconClass = classNames(aIconClass);
        return (
            <tr key={iEventId}>
                <td className="time-stamp">{sEventTime}</td>
                <td className={sIconClass}></td>
                <td className="game-details" dangerouslySetInnerHTML={{__html:sEventText}}></td>
            </tr>
        );

    }
});

module.exports = Commentary;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/Commentary.jsx
 **/